import { CarouselBase, CarouselButtons } from "ui"
import { useSlidesPerView } from "hooks"
import { Title, CarouselContainer } from "./styles"
import { useEffect, useState } from "react"


const Slides = ({ children, defaultSlidePosition }) => {
  const [slidesPerView, setSlidesPerView] = useState(6)
  
  useEffect(() => {
    const getSelidesPerView = () => {
      const { width } = document.body.getBoundingClientRect()
      if (width < 500) setSlidesPerView(1)
      else if (width < 1000) setSlidesPerView(2)
      else if (width < 1400) setSlidesPerView(3)
      else if (width < 2400) setSlidesPerView(4)
      else setSlidesPerView(5)
    }

    getSelidesPerView()
    window.addEventListener('resize', getSelidesPerView)
    return () => window.removeEventListener('resize', getSelidesPerView)
  }, [])

  return (
    <CarouselContainer>
      <CarouselBase
        slidesPerView={slidesPerView}
        renderNavigationBtns={CarouselButtons}
        defaultSlidePosition={defaultSlidePosition}
        rewind
      >
        {children}
      </CarouselBase>
    </CarouselContainer>
  )
}


const Carousel = {
  Title,
  Slides
}

export default Carousel